<script setup lang="ts">
definePageMeta({
    hidePromotions: true
})
const route = useRoute()
const slug = route.params?.slug as string

// Article + related list from Nuxt Content;
// NimbusPressDetails computes related posts and the SEO tags from them.
const { data: pressArticle } = await usePressArticleData(slug)
const { data: pressArticles } = await usePressData()
</script>

<template>
    <NimbusPressDetails
        :text="{
            back: 'Back',
            otherNews: 'Other articles and press material'
        }"
        no-posts-text="Unfortunately, we could not find any posts. Please refresh the page or try again later."
        :article="pressArticle"
        :articles="pressArticles ?? undefined"
    />
</template>
